'use es6';

import { Map as ImmutableMap, List } from 'immutable';
import { REQUESTED_LISTS, RECEIVED_LISTS } from '../constants/actionTypes';
import { UNINITIALIZED, PENDING, SUCCEEDED } from '../constants/requestStatusTypes';
const initialState = ImmutableMap({
  status: UNINITIALIZED,
  allLists: List(),
  staticLists: List()
});
export default function lists(state = initialState, action) {
  switch (action.type) {
    case REQUESTED_LISTS:
      return state.merge({
        status: PENDING
      });
    case RECEIVED_LISTS:
      return state.merge({
        status: SUCCEEDED,
        allLists: action.payload.get('lists'),
        staticLists: action.payload.get('lists').filterNot(list => list.get('dynamic'))
      });
    default:
      return state;
  }
}